import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import CompareTable from '../CompareTable'
import ImageCompareBox from '../ImageCompareBox'
import CompareBox from '../CompareBox'
import CompareIconArray from '../CompareIconArray'
import LoadingIndicator from '@healthwise-ui/core/LoadingIndicator'
import Paragraph from '../Paragraph'
import ListItem from '../ListItem'
import UnorderedList from '../UnorderedList'
import SvgImage from '@healthwise-ui/core/SvgImage'
import ComponentBuilder from '../../archetypes/ComponentBuilder'

class InfoConcept extends Component {
  constructor (props) {
    super(props)
    this.getComponentMap.bind(this)
  }

  getComponentMap (aspect, title, sectionIndex, currentLocation) {
    let componentMap = [
      {
        when: (node) => { return node && (node.tagName || '').toLowerCase() === 'p' },
        use: Paragraph
      },
      {
        when: (node) => { return node && (node.tagName || '').toLowerCase() === 'ul' },
        use: UnorderedList
      },
      {
        when: (node) => { return node && (node.tagName || '').toLowerCase() === 'h3' },
        ignore: true
      },
      {
        when: (node) => { return node && (node.tagName || '').toLowerCase() === 'table' && currentLocation === 'compare' },
        use: CompareTable
      },
      {
        when: (node) => { return node && (node.tagName || '').toLowerCase() === 'li' },
        use: ListItem
      },
      {
        when: (node) => { return node && (node.tagName || '').toLowerCase() === 'iconarray' },
        use: CompareIconArray
      },
      {
        when: (node) => { return node && (node.tagName || '').toLowerCase() === 'img' && (node.getAttribute('class') || '').toLowerCase().indexOf('hwicontitle') !== -1 },
        ignore: true
      },
      {
        when: (node) => { return node && (node.tagName || '').toLowerCase() === 'img' && (new RegExp('^https?://.*\\.svg$')).test(node.getAttribute('src')) },
        use: SvgImage
      }
    ]

    if ((aspect || '').indexOf('[decisionOptions]') !== -1) {
      componentMap.push({
        when: (node) => { return node && (node.getAttribute('class') || '').indexOf('HwDecisionComponent') !== -1 && this.doesDescendantNodeHaveClassName(node, 'HwImageWrapper') },
        use: ImageCompareBox
      })
      componentMap.push({
        when: (node) => { return node && (node.getAttribute('class') || '').indexOf('HwDecisionComponent') !== -1 },
        use: CompareBox
      })
      componentMap.unshift({
        when: (node) => {
          return node && (node.tagName || '').toLowerCase() === 'h3' && node.parentElement && (node.parentElement.className || '') === 'HwSection'
        },
        use: 'span'
      })
    }

    return componentMap
  }

  componentDidMount () {
    this.generateReactComponents()
  }

  render () {
    return (
      <div ref={(wrapper) => { this.wrapper = wrapper }}><LoadingIndicator /></div>
    )
  }

  doesDescendantNodeHaveClassName (parent, className) {
    let isSuccessful = false
    if (parent && parent.childNodes) {
      for (let key in parent.childNodes) {
        if (parent.childNodes.hasOwnProperty(key)) {
          const node = parent.childNodes[key]
          if (node.tagName) {
            if (node && (node.getAttribute('class') || '').indexOf(className) !== -1) {
              isSuccessful = true
              break
            } else {
              isSuccessful = isSuccessful || this.doesDescendantNodeHaveClassName(node, className)
            }
          }
        }
      }
    }
    return isSuccessful
  }

  generateReactComponents () {
    const {item, title, sectionIndex, currentLocation} = this.props
    const componentBuilder = new ComponentBuilder({
      componentMap: this.getComponentMap(item.aspect, title, sectionIndex, currentLocation)
    })
    const component = componentBuilder.build(item.html)
    this.wrapper.innerHTML = ''
    ReactDOM.render(component, this.wrapper)
  }
}

InfoConcept.propTypes = {
  sectionIndex: PropTypes.number,
  currentLocation: PropTypes.string,
  title: PropTypes.string,
  item: PropTypes.shape({
    html: PropTypes.string.isRequired,
    aspect: PropTypes.string,
    type: PropTypes.oneOf(['hwDecisionComponent']).isRequired
  }).isRequired
}

export default InfoConcept



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/InfoConcept/index.js